module.exports = __webpack_public_path__ + "static/img/pic5.256027e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic5.jpg
// module id = 3kaU
// module chunks = 1